module.exports = __webpack_public_path__ + "h5/img/C.ebe54151.png";